<script setup lang="ts">
import { quantityBus } from '@/event/product/quantityBus'
import { ref } from 'vue'

const counterProduct = ref(quantityBus.value ? quantityBus.value : 0)

function increment() {
    counterProduct.value++
    quantityBus.value = counterProduct.value
}

function decrement() {
    if (counterProduct.value > 1) {
        counterProduct.value--
        quantityBus.value = counterProduct.value
    }
}
</script>

<template>
    <section class="section-button-select-product-happy">
        <div class="min-w-6 min-h-6">
            <button
                class="button-minus-product-happy"
                @click.stop="decrement()"
                v-if="counterProduct > 1"
            >
                <svg
                    class="svg-minus-happy"
                    viewBox="0 0 15 2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 1H14"
                        stroke-linecap="round"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterProduct }}</p>

        <button class="button-plus-product-happy" @click.stop="increment()">
            <svg
                class="svg-plus-happy"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 8.5H16M8.5 1V16"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
    </section>
</template>

<style scoped>
.section-button-select-product-happy {
    @apply flex items-center justify-between gap-2 min-w-28;
}

.button-minus-product-happy {
    @apply flex items-center border-2 shadow-sm rounded-md p-1;
    @apply happy-light:border-button-yellow-happy-light happy-light:shadow-bg-gray-sand;
    @apply happy-dark:border-button-yellow-happy-light happy-dark:shadow-text-dark-happy-light;
    @apply happy-urban-dark-red:bg-urban-red happy-urban-dark-red:border-urban-red happy-urban-dark-red:shadow-text-dark-happy-light;
    @apply happy-urban-light-red:bg-urban-red happy-urban-light-red:border-urban-red happy-urban-light-red:shadow-bg-gray-sand;
    @apply happy-orange-light:bg-bg-orange happy-orange-light:border-bg-orange happy-orange-light:shadow-bg-gray-sand;
    @apply happy-orange-dark:bg-urban-dark happy-orange-dark:border-urban-dark happy-orange-dark:shadow-urban-dark;
    @apply happy-fresh-mint:bg-bg-mint happy-fresh-mint:border-bg-mint happy-fresh-mint:shadow-bg-happy-light;
    @apply happy-bee-light:border-bee-yellow happy-bee-light:shadow-bg-happy-light happy-bee-light:bg-bee-yellow;
    @apply happy-bee-dark:border-bee-yellow happy-bee-dark:shadow-urban-dark happy-bee-dark:bg-bee-yellow;
    @apply happy-earth-stone:border-urban-dark happy-earth-stone:shadow-urban-dark happy-earth-stone:bg-urban-dark;
    @apply happy-scorched-earth:border-scorched-earth-yellow happy-scorched-earth:shadow-urban-dark happy-scorched-earth:bg-scorched-earth-yellow;
    @apply happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark happy-sand-sky:bg-bg-sand;
    @apply happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark happy-gray-sand:bg-bg-gray-sand;
}

.svg-minus-happy {
    @apply w-[18px] h-[18px];
    @apply happy-light:text-bg-happy-light;
    @apply happy-dark:text-text-dark-happy-light;
    @apply happy-urban-dark-red:text-bg-happy-light;
    @apply happy-urban-light-red:text-bg-happy-light;
    @apply happy-orange-light:text-urban-dark;
    @apply happy-orange-dark:text-bg-happy-light;
    @apply happy-fresh-mint:text-bg-happy-light;
    @apply happy-bee-light:text-urban-dark;
    @apply happy-bee-dark:text-urban-dark;
    @apply happy-earth-stone:text-bg-happy-light;
    @apply happy-scorched-earth:text-urban-dark;
    @apply happy-sand-sky:text-urban-dark;
    @apply happy-gray-sand:text-urban-dark;
}

.text-counter-option-value-happy {
    @apply text-lg text-center w-6 font-semibold;
    @apply happy-light:text-bg-happy-light;
    @apply happy-dark:text-text-dark-happy-light;
    @apply happy-urban-dark-red:text-urban-dark;
    @apply happy-urban-light-red:text-bg-happy-light;
    @apply happy-orange-light:text-bg-happy-light;
    @apply happy-orange-dark:text-urban-dark;
    @apply happy-fresh-mint:text-bg-happy-light;
    @apply happy-bee-light:text-bg-happy-light;
    @apply happy-bee-dark:text-urban-dark;
    @apply happy-earth-stone:text-urban-dark;
    @apply happy-scorched-earth:text-bg-happy-light;
    @apply happy-sand-sky:text-bg-happy-light;
    @apply happy-gray-sand:text-urban-dark;
}

.button-plus-product-happy {
    @apply flex items-center p-1 shadow-sm rounded-md border-2;
    @apply happy-light:bg-button-yellow-happy-light happy-light:border-button-yellow-happy-light happy-light:shadow-bg-gray-sand;
    @apply happy-dark:bg-button-yellow-happy-light happy-dark:border-button-yellow-happy-light happy-dark:shadow-text-dark-happy-light;
    @apply happy-urban-dark-red:bg-urban-red happy-urban-dark-red:border-urban-red happy-urban-dark-red:shadow-text-dark-happy-light;
    @apply happy-urban-light-red:bg-urban-red happy-urban-light-red:border-urban-red happy-urban-light-red:shadow-bg-gray-sand;
    @apply happy-orange-light:bg-bg-orange happy-orange-light:border-bg-orange happy-orange-light:shadow-bg-gray-sand;
    @apply happy-orange-dark:bg-urban-dark happy-orange-dark:border-urban-dark happy-orange-dark:shadow-urban-dark;
    @apply happy-fresh-mint:bg-bg-mint happy-fresh-mint:border-bg-mint happy-fresh-mint:shadow-bg-happy-light;
    @apply happy-bee-light:bg-bee-yellow happy-bee-light:border-bee-yellow happy-bee-light:shadow-bg-happy-light;
    @apply happy-bee-dark:bg-bee-yellow happy-bee-dark:border-bee-yellow happy-bee-dark:shadow-urban-dark;
    @apply happy-earth-stone:bg-urban-dark happy-earth-stone:border-urban-dark happy-earth-stone:shadow-urban-dark;
    @apply happy-scorched-earth:bg-scorched-earth-yellow happy-scorched-earth:border-scorched-earth-yellow happy-scorched-earth:shadow-urban-dark;
    @apply happy-sand-sky:bg-bg-sand happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark;
    @apply happy-gray-sand:bg-bg-gray-sand happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark;
}
.svg-plus-happy {
    @apply w-[18px] h-[18px];
    @apply happy-light:stroke-text-dark-happy-light;
    @apply happy-dark:stroke-text-dark-happy-light;
    @apply happy-urban-dark-red:stroke-white;
    @apply happy-urban-light-red:stroke-white;
    @apply happy-orange-light:stroke-urban-dark;
    @apply happy-orange-dark:stroke-white;
    @apply happy-fresh-mint:stroke-bg-happy-light;
    @apply happy-bee-light:stroke-urban-dark;
    @apply happy-bee-dark:stroke-urban-dark;
    @apply happy-earth-stone:stroke-bg-happy-light;
    @apply happy-scorched-earth:stroke-urban-dark;
    @apply happy-sand-sky:stroke-urban-dark;
    @apply happy-gray-sand:stroke-urban-dark;
}

.button-plus-product-happy:active,
.button-plus-product-happy:focus {
    @apply happy-light:bg-hover-yellow-happy happy-light:border-hover-yellow-happy;
    @apply happy-dark:bg-hover-yellow-happy happy-dark:border-hover-yellow-happy;
    @apply happy-urban-dark-red:bg-urban-dark happy-urban-dark-red:border-urban-red;
    @apply happy-urban-light-red:bg-urban-dark happy-urban-light-red:border-urban-red;
    @apply happy-orange-light:bg-bg-orange-dark happy-orange-light:border-bg-orange-dark;
    @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-urban-dark;
    @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint;
    @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow;
    @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bee-yellow;
    @apply happy-earth-stone:bg-earth-card-dark happy-earth-stone:border-urban-dark;
    @apply happy-scorched-earth:bg-bg-scorched-earth happy-scorched-earth:border-scorched-earth-yellow;
    @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark;
    @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark;
}

.button-plus-product-happy:active .svg-plus-happy,
.button-plus-product-happy:focus .svg-plus-happy {
    @apply happy-light:stroke-text-dark-happy-light;
    @apply happy-dark:stroke-text-dark-happy-light;
    @apply happy-urban-dark-red:stroke-white;
    @apply happy-urban-light-red:stroke-white;
    @apply happy-orange-light:stroke-white;
    @apply happy-orange-dark:stroke-white;
    @apply happy-fresh-mint:stroke-bg-happy-light;
    @apply happy-bee-light:stroke-bg-happy-light;
    @apply happy-bee-dark:stroke-bg-happy-light;
    @apply happy-earth-stone:stroke-bg-happy-light;
    @apply happy-scorched-earth:stroke-urban-dark;
    @apply happy-sand-sky:stroke-urban-dark;
    @apply happy-gray-sand:stroke-urban-dark;
}

.button-minus-product-happy:active,
.button-minus-product-happy:focus {
    @apply bg-hover-yellow-happy border-hover-yellow-happy;
    @apply happy-light:bg-hover-yellow-happy happy-light:border-hover-yellow-happy;
    @apply happy-dark:bg-hover-yellow-happy happy-dark:border-hover-yellow-happy;
    @apply happy-urban-dark-red:bg-urban-dark happy-urban-dark-red:border-urban-red;
    @apply happy-urban-light-red:bg-urban-dark happy-urban-light-red:border-urban-red;
    @apply happy-orange-light:bg-bg-orange-dark happy-orange-light:border-bg-orange-dark;
    @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-urban-dark;
    @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint;
    @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow;
    @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bee-yellow;
    @apply happy-earth-stone:bg-earth-card-dark happy-earth-stone:border-urban-dark;
    @apply happy-scorched-earth:bg-bg-scorched-earth happy-scorched-earth:border-scorched-earth-yellow;
    @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark;
    @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark;
}

.button-minus-product-happy:active .svg-minus-happy,
.button-minus-product-happy:focus .svg-minus-happy {
    @apply happy-light:text-text-dark-happy-light;
    @apply happy-dark:text-text-dark-happy-light;
    @apply happy-urban-dark-red:text-white;
    @apply happy-urban-light-red:text-white;
    @apply happy-orange-light:text-urban-dark;
    @apply happy-orange-light:text-white;
    @apply happy-orange-dark:text-white;
    @apply happy-fresh-mint:text-bg-happy-light;
    @apply happy-bee-light:text-bg-happy-light;
    @apply happy-bee-dark:text-bg-happy-light;
    @apply happy-earth-stone:text-bg-happy-light;
    @apply happy-scorched-earth:text-urban-dark;
    @apply happy-sand-sky:text-urban-dark;
    @apply happy-gray-sand:text-urban-dark;
}

@media (hover: hover) {
    .button-plus-product-happy:hover {
        @apply happy-light:bg-hover-yellow-happy happy-light:border-hover-yellow-happy;
        @apply happy-dark:bg-hover-yellow-happy happy-dark:border-hover-yellow-happy;
        @apply happy-urban-dark-red:bg-urban-dark happy-urban-dark-red:border-urban-red;
        @apply happy-urban-light-red:bg-urban-dark happy-urban-light-red:border-urban-red;
        @apply happy-orange-light:bg-urban-dark happy-orange-light:border-bg-orange-dark;
        @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-urban-dark;
        @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint;
        @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow;
        @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bee-yellow;
        @apply happy-earth-stone:bg-earth-card-dark happy-earth-stone:border-urban-dark;
        @apply happy-scorched-earth:bg-bg-scorched-earth happy-scorched-earth:border-scorched-earth-yellow;
        @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark;
        @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark;
    }

    .button-plus-product-happy:hover .svg-plus-happy {
        @apply happy-light:stroke-text-dark-happy-light;
        @apply happy-dark:stroke-text-dark-happy-light;
        @apply happy-urban-dark-red:stroke-white;
        @apply happy-urban-light-red:stroke-white;
        @apply happy-orange-light:stroke-white;
        @apply happy-orange-dark:stroke-white;
        @apply happy-fresh-mint:stroke-bg-happy-light;
        @apply happy-bee-light:stroke-bg-happy-light;
        @apply happy-bee-dark:stroke-bg-happy-light;
        @apply happy-earth-stone:stroke-bg-happy-light;
        @apply happy-scorched-earth:stroke-urban-dark;
        @apply happy-sand-sky:stroke-urban-dark;
        @apply happy-gray-sand:stroke-urban-dark;
    }

    .button-minus-product-happy:hover {
        @apply happy-light:bg-hover-yellow-happy happy-light:border-hover-yellow-happy;
        @apply happy-dark:bg-hover-yellow-happy happy-dark:border-hover-yellow-happy;
        @apply happy-urban-dark-red:bg-urban-dark happy-urban-dark-red:border-urban-red;
        @apply happy-urban-light-red:bg-urban-dark happy-urban-light-red:border-urban-red;
        @apply happy-orange-light:bg-urban-dark happy-orange-light:border-bg-orange;
        @apply happy-orange-dark:bg-bg-orange-dark happy-orange-dark:border-urban-dark;
        @apply happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:border-bg-mint;
        @apply happy-bee-light:bg-bee-yellow-dark happy-bee-light:border-bee-yellow;
        @apply happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:border-bee-yellow;
        @apply happy-earth-stone:bg-earth-card-dark happy-earth-stone:border-urban-dark;
        @apply happy-scorched-earth:bg-bg-scorched-earth happy-scorched-earth:border-scorched-earth-yellow;
        @apply happy-sand-sky:bg-sand-blue happy-sand-sky:border-bg-sand happy-sand-sky:shadow-urban-dark;
        @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:border-bg-gray-sand happy-gray-sand:shadow-urban-dark;
    }

    .button-minus-product-happy:hover .svg-minus-happy {
        @apply happy-light:text-text-dark-happy-light;
        @apply happy-dark:text-text-dark-happy-light;
        @apply happy-urban-dark-red:text-white;
        @apply happy-urban-light-red:text-white;
        @apply happy-orange-light:text-bg-happy-light;
        @apply happy-orange-dark:text-white;
        @apply happy-fresh-mint:text-bg-happy-light;
        @apply happy-bee-light:text-bg-happy-light;
        @apply happy-bee-dark:text-bg-happy-light;
        @apply happy-earth-stone:text-bg-happy-light;
        @apply happy-scorched-earth:text-urban-dark;
        @apply happy-sand-sky:text-urban-dark;
        @apply happy-gray-sand:text-urban-dark;
    }
}
</style>
